module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "img10"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line1.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("FOREWORD")]), _vm._v(" "), _c('p', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pgbrk"
  }), _c('p', {
    staticClass: "para2"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("n reading Tikva Frymer-Kensky’s meditations on the witch—the medium, the necromancer, the wise woman—of Endor, I was reminded powerfully of Tikva herself: a wise woman, gifted scholar, true mentsch, and trailblazer. Tikva showed women biblical scholars like me what was possible in a guild that was not overly eager to welcome us. Above all, she showed us through her words, and through her very own way of being in the world, how biblical stories, especially those about women, were not only fascinating in what they revealed about the biblical narrative in its ancient contexts but also had lessons for us today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These same qualities are evident, in abundance, in this short book. Tikva’s reflections on an intriguing biblical figure offer lessons that provide deeper insight into the story of King Saul’s secretive encounter with this wise woman. We sense Saul’s despair and the woman’s growing understanding that despite the king’s earlier proscriptions against necromancy, she had the power, knowledge, and wisdom to help him at this terrifying point in his own life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On these pages, however, the wise witch of Endor, as channeled by Tikva, can guide us all, as perhaps she did for Tikva during her illness. The qualities that Tikva finds in the witch of Endor are those we all need in order to succeed in life and in our careers: determination, excellence, caution, and benevolence. We should all know our power, strive to excel, choose the moment, and win well; we would do well not to give up on our dreams too early but also to be wise enough to know that our goals may need to change. In doing so, we can hope to grow into magnanimity, with our spirits large and at peace with ourselves and others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Most readers of Tikva’s final gift will not have known her in her lifetime, but through this book and her many other writings, they will continue to learn from her about the Bible and about life itself.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DELE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EINHARTZ")])]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('span', {
    staticClass: "pad"
  }, [_c('em', [_vm._v("University of Ottawa")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17965785","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Foreword.vue
// module id = 69
// module chunks = 0